import { type ReduxStateShared } from '~shared/types';

/**
 * Gets route state for a component on web. Noop for native.
 */
const getRouteState = (state: ReduxStateShared) => state.routing?.locationBeforeTransitions?.state || {};

export default getRouteState;
